export default {
    CURRENCY_TYPES: {
        MONEY: 'MONEY',
        POINTS: 'POINTS',
    },
    TYPES: {
        EARN: 'earn',
        BOTH: 'both',
        BURN: 'redeem',
        NONE: 'none',
    },
    TRANSACTIONS_STATUSES: {
        PENDING: 'Pending',
        COMPLETE: 'Complete',
        FAILURE: 'Failure',
        CANCELLED: 'Cancelled',
    },
    STATISTICS: {
        TYPE: {
            US_DOLLAR: 'usDollar',
            LOYALTY_CURRENCY: 'loyaltyCurrency',
        },
    },
};
